import React, { useEffect, useState } from 'react';
import { Link, useParams } from "react-router-dom";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Project_Ledger_Inner from './Project_Ledger_Inner';
import Loader from './Loader';
import Skeleton from 'react-loading-skeleton';  // Importing skeleton loader
import 'react-loading-skeleton/dist/skeleton.css'; // Import the skeleton styles
import axios from 'axios';
import { API_BASE_URL } from '../../api';
import { priceInWords } from '../../Helpers'

const Project_view = () => {
    const [project, setProject] = useState(null);  // Single project state
    const [client, setClient] = useState(null);    // Client data state
    const { id } = useParams();  // Get the project ID from URL params
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    useEffect(() => {
        const fetchProject = async () => {
            const response = await fetch(`${API_BASE_URL}/api/project/${id}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("authToken")}`,
                    'User-Id': localStorage.getItem("userId"),
                },
            });

            if (response.ok) {
                const data = await response.json();
                setProject(data);  // Set the project to state
                setClient(data.client); // Fetch client data after project
            } else {
                console.error('Failed to fetch project data');
            }
        };


        fetchProject();
    }, [id]);

    const toggleSidebar = () => {
        setIsSidebarOpen((prevState) => !prevState);
    };

    useEffect(() => {
        if (isSidebarOpen) {
            document.body.classList.add("toggle-sidebar");
        } else {
            document.body.classList.remove("toggle-sidebar");
        }

        return () => {
            document.body.classList.remove("toggle-sidebar");
        };
    }, [isSidebarOpen]);

    const toCamelCase = (str) => {
        const camelCased = str.replace(/_([a-z])/g, (match, group1) => group1.toUpperCase());
        return camelCased.charAt(0).toUpperCase() + camelCased.slice(1);
    };

    if (!project || !client) {
        return (
            <div>
                <Navbar toggleSidebar={toggleSidebar} />
                <Sidebar isOpen={isSidebarOpen} />
                <main id='main' className='main'>
                    <section className='section'>
                        <div className="row">
                            <div className="col-12">
                                <div className="content">
                                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                                        <div className="my-auto mb-2 text-start">
                                            <div className="pagetitle">
                                                <h1>View-Project</h1>
                                                <nav>
                                                    <ol className="breadcrumb">
                                                        <li className="breadcrumb-item">
                                                            <a href="javascript:void(0)">Home</a>
                                                        </li>
                                                        <li className='breadcrumb-item'>View-Project</li>
                                                    </ol>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xxl-12 ">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="bg-light rounded p-3 mb-3">
                                                    <div className="d-flex align-items-center">
                                                        <div className="text-start">
                                                            <Skeleton height={30} width={200} />
                                                            <Skeleton height={20} width={100} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <Skeleton count={6} height={30} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
                <Footer />
            </div>
        );
    }

    return (
        <div>
            <Navbar toggleSidebar={toggleSidebar} />
            <Sidebar isOpen={isSidebarOpen} />
            <main id='main' className='main'>
                <section className='section'>
                    <div className='row'>
                        <div className="col-12">
                            <div className="content">
                                <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                                    <div className="my-auto mb-2 text-start">
                                        <div className="pagetitle">
                                            {/* <h1>View-Project</h1> */}
                                            <nav>
                                                <ol className="breadcrumb">
                                                    <li className="breadcrumb-item">
                                                        <a href="javascript:void(0)">Home</a>
                                                    </li>
                                                    <li className='breadcrumb-item'>Project</li>
                                                    <li className='breadcrumb-item'>View</li>
                                                    <li className='breadcrumb-item'>{project.project_name}</li>
                                                </ol>
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-12 ">
                                    <div className="card">
                                        <div className="card-body">
                                            {/* <div className="bg-light rounded p-3 mb-3">
                                                <div className="d-flex align-items-center">
                                                    <div className="text-start">
                                                        <h6 className="mb-1">{project.project_name}</h6>
                                                        <p>Project ID : <span className="text-primary"> SAI-{project.id}</span></p>
                                                    </div>
                                                </div>
                                            </div> */}
                                            <table className="table table-bordered text-start">
                                                <tbody>
                                                    <tr>
                                                        <th scope="row">Status</th>
                                                        <td>
                                                            <span
                                                                className={`badge ${project.status === "pending"
                                                                    ? "badge-warning"
                                                                    : project.status === "active"
                                                                        ? "badge-success"
                                                                        : project.status === "inactive"
                                                                            ? "badge-secondary"
                                                                            : "badge-info"
                                                                    }`}
                                                            >
                                                                {toCamelCase(project.status)}
                                                            </span></td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Agent</th>
                                                        <td>
                                                            <span className={`badge ${project.agent === 'MEET' ? 'bg-primary' : project.agent === 'BRIJESH' ? 'bg-success' : project.agent === 'NISHANTSIR' ? 'bg-warning' : 'bg-info'}`}>
                                                                {project.agent}
                                                            </span></td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Project Name</th>
                                                        <td>{toCamelCase(project.project_name)}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Client Name</th>
                                                        <td>{toCamelCase(client.full_name)}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Start Date</th>
                                                        <td>{project.start_date}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">End Date</th>
                                                        <td>{project.end_date}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Amount</th>
                                                        <td>{project.amount} - <span id="amountinword">{priceInWords(project.amount)}</span></td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Renewal Period</th>
                                                        <td>{project.renewal_month} Month</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Package</th>
                                                        <td>{project.package}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Remarks</th>
                                                        <td className="ellipsis">{toCamelCase(project.remarks)}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                            <h5>Project Ledger</h5>
                                            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                                                <div className="mb-2">
                                                    <Link to={`/dashboard/add-ledger/${id}/${client.id}`} title="Add Ledger"
                                                        className="btn btn-primary d-flex align-items-center">
                                                        <i className="fa fa-plus-circle me-2"></i>New Entry
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                        <Project_Ledger_Inner />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
};

export default Project_view;
